import { render, staticRenderFns } from "./NewVerticalNavMenuItem.vue?vue&type=template&id=49f9a300&scoped=true&"
import script from "./NewVerticalNavMenuItem.vue?vue&type=script&lang=js&"
export * from "./NewVerticalNavMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./NewVerticalNavMenuItem.vue?vue&type=style&index=0&id=49f9a300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f9a300",
  null
  
)

export default component.exports